import React from 'react';
import { getPermissionsForModule, Scopes } from 'src/app/scopes/scopes';

import Create from './Children/Create';
import Dashboard from './Children/Dashboard';
import Terminals from './Children/Terminals';
import Update from './Children/Update';
import Info from './Children/Info';

export const RecognitionConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'recognitionGroup',
      path: 'recognition',
      scopes: getPermissionsForModule('Recognition'),
      children: [
        {
          scopes: [Scopes.Recognition.show],
          id: 'recognitionGroup.dashboard',
          path: 'dashboard',
          element: <Dashboard />,
        },
        {
          scopes: [Scopes.Recognition.show],
          id: 'recognitionGroup.terminals',
          path: '',
          element: <Terminals />,
        },
        {
          scopes: [Scopes.Recognition.store],
          id: 'recognitionGroup.create',
          path: 'create',
          element: <Create />,
        },
        {
          scopes: [Scopes.Recognition.update],
          id: 'recognitionGroup.update',
          path: 'update',
          element: <Update />,
        },
        {
          scopes: [Scopes.Company.show],
          id: 'recognitionGroup.info',
          path: 'info',
          element: <Info />,
        },
      ],
    },
  ],
};
